// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d4476f38","298":"24bfe38d","453":"b62b13c1","888":"a03b1204"}[chunkId] + ".chunk.js";
};